import { CameraIcon } from 'components/Icon';

import styles from './SessionExpired.module.scss';

const SessionExpired = () => (
  <div className={styles.container}>
    <CameraIcon />
    <h3>You are attending event on other browser tab</h3>
  </div>
);

export default SessionExpired;
